/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BackgroundJobPayloadForModelSwitching extends models.BackgroundJobPayloadBase {
    constructor() {
        super();
        this.setDiscriminator("BackgroundJobPayloadForModelSwitching");
    }

    getFixupPrototypeFunction() { return BackgroundJobPayloadForModelSwitching.fixupPrototype; }

    static newInstance(model: Partial<BackgroundJobPayloadForModelSwitching>): BackgroundJobPayloadForModelSwitching {
        let obj = Object.assign(new BackgroundJobPayloadForModelSwitching(), model);
        BackgroundJobPayloadForModelSwitching.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BackgroundJobPayloadForModelSwitching>): BackgroundJobPayloadForModelSwitching {
        if (!model) return null;
        return BackgroundJobPayloadForModelSwitching.newInstance(<BackgroundJobPayloadForModelSwitching> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BackgroundJobPayloadForModelSwitching) {
        if (!obj) return;

        models.BackgroundJobPayloadForModelSwitching.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BackgroundJobPayloadForModelSwitching): boolean {
        if (models.BackgroundJobPayloadBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, BackgroundJobPayloadForModelSwitching.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Service account whose profiled prompts to generate recommendations for
     */
    service_account_id: string;

    /**
     * Optional: single prompt ID for on-demand recommendation
     */
    prompt_id: string;

}
